import React, { Component } from 'react'
import Header from '../header';
import Banner   from '../homebanner';
import News from './news';
import ReviewUs from './reviewus';
import Experiences   from './experiences';
import withMedia from '../../containers/withmedia';
import Offers from './offers';
import Resorts from './resorts';
import Awards from '../../containers/awards';
import Dots from '../../lib/dotsloader';
import Footer from './footer';
import MissSunrise from './misssunrise';
import style from './style.css';

class HomeScreen extends Component {

    render() {
        const is_large = this.props.browser.greaterThan.small
        return (
            <div className={ style.rootContainer }>
                <Header />
                <Banner />
                <div className={ style.container }>
                    <Experiences />
                    <div className={ is_large ? `container no-padding` : `` }>
                        <Resorts/>
                        { this.props.browser && this.props.browser.lessThan.small && <Offers /> }
                        <News />
                    { false &&
                    <div>
                        <Awards />
                        <ReviewUs />
                    </div>
                    }
                      </div>
                </div>
                { true && <Footer slug="frontpage"/> }
            </div> 
        )
    }
}

export default withMedia(HomeScreen)



// WEBPACK FOOTER //
// ./src/components/homescreen/index.js